import { usePermanentLeaseCompanyOptionsQuery, usePermanentStorageLocationOptionsQuery } from "components/DBB/components/DBBCreateContractModal/hooks";
import { useCarLocation } from "modules/CarDetails/hooks/useCarLocation";

import type { Car } from "models";

export const useDBBContractOptions = (car: Car) => {
  const carLocation = useCarLocation(car);

  const { data: leaseCompanyOptions = [], isFetching: isFetchingLeaseCompanies } = usePermanentLeaseCompanyOptionsQuery(carLocation);
  const { data: storageLocationOptions = [], isFetching: isFetchingStorageLocations } = usePermanentStorageLocationOptionsQuery(carLocation);

  return { leaseCompanyOptions, storageLocationOptions, isFetchingLeaseCompanies, isFetchingStorageLocations };
};
